import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { ClassAttributes, createElement, MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = ClassAttributes<HTMLElement> & {
  onClickAcceptButton: MouseEventHandler<HTMLElement>;
  onRequestClose: MouseEventHandler<HTMLElement>;
  open?: boolean;
  className?: string;
};

const ModificationRequestAlertFeeDialog = ({ onClickAcceptButton, onRequestClose, open, className, key }: Props) => {
  const ariaLabelledBy = `project-publishing-dialog-title-${key}`;
  const ariaDescribedBy = `project-publishing-dialog-description-${key}`;

  return (
    <Dialog
      open={!!open}
      onClose={onRequestClose}
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDescribedBy}
      className={className}
    >
      <DialogTitle id={ariaLabelledBy}>
        <FormattedMessage id="modification_request_creating_card.change_fee_type_to_fee_alert_dialog.title" />
      </DialogTitle>

      <DialogContent>
        <DialogContentText id={ariaDescribedBy}>
          <FormattedMessage id="modification_request_creating_card.change_fee_type_to_fee_alert_dialog.description" />
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onRequestClose} variant="text">
          <FormattedMessage id="modification_request_creating_card.change_fee_type_to_fee_alert_dialog.decline" />
        </Button>

        <Button onClick={onClickAcceptButton} variant="text" autoFocus>
          <FormattedMessage id="modification_request_creating_card.change_fee_type_to_fee_alert_dialog.accept" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModificationRequestAlertFeeDialog;
